'use client'

import * as React from 'react'
import { ShowcaseStrip } from '@repo/studio-components-showcase-strip/showcase-strip'
import { InfiniteCarousel } from '../infinite-carousel'
import { FeaturedTemplateItem } from './featured-template-item'

interface FeaturedTemplate {
  id: string
  name: string
  thumbnailUrl: string | undefined
  videoUrl: string | undefined
}

interface FeaturedTemplatesCarouselProps {
  title: string
  scrollLeftLabel: string
  scrollRightLabel: string
  templates: FeaturedTemplate[]
  className?: string
}

export function FeaturedTemplatesCarousel({
  title,
  scrollLeftLabel,
  scrollRightLabel,
  templates,
  className = '',
}: FeaturedTemplatesCarouselProps) {
  const loopedTemplates = React.useMemo(
    () => [...templates, ...templates, ...templates],
    [templates],
  )

  return (
    <ShowcaseStrip.Root className={`gap-2 ${className}`}>
      <ShowcaseStrip.Title className="text-base font-semibold font-poppins text-cf-black">
        {title}
      </ShowcaseStrip.Title>
      <InfiniteCarousel
        itemCount={templates.length}
        scrollLeftLabel={scrollLeftLabel}
        scrollRightLabel={scrollRightLabel}
      >
        {loopedTemplates.map((template, index) => {
          const setIndex = Math.floor(index / templates.length)
          return (
            <FeaturedTemplateItem
              key={`${template.id}-${setIndex}`}
              data-card
              name={template.name}
              thumbnailUrl={template.thumbnailUrl}
              videoUrl={template.videoUrl}
            />
          )
        })}
      </InfiniteCarousel>
    </ShowcaseStrip.Root>
  )
}
